"use client";

import React from "react";
import styles from "../about.module.css";
import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";
import { stripHTML, sanitizeHTMLKeepStyleWithFont } from "@/utils/stripHTML";
import { Title, Description } from "@/components/Common/Typography";

export interface WhyChooseItem {
  title: string;
  description: string;
  picture?: string;
}

export default function WhyChooseSection({
  title = "Lý do chọn Việt Thiên",
  items = [],
  chonVietThien,
}: {
  title?: string;
  items?: WhyChooseItem[];
  chonVietThien?: any[];
}) {
  // Ưu tiên sử dụng parsed items mới từ add_on_data (ly-do-chon-viet-thien).
  // Fallback về format cũ chonVietThien nếu chưa có.
  let displayTitle = title;
  let displayItems = items;

  if (displayItems.length === 0 && Array.isArray(chonVietThien) && chonVietThien.length >= 2) {
    displayTitle = stripHTML(chonVietThien[1]?.title || title);
    displayItems = [2, 3, 4]
      .map((index) => chonVietThien[index])
      .filter(Boolean)
      .map((item) => ({
        title: stripHTML(item.title || ""),
        description: item.content || "",
        picture: appendImageUrlFromAPI({ src: item.picture, size: "2k" }),
      }));
  }

  if (displayItems.length === 0) return null;

  return (
    <section className="pt-24 pb-72 bg-transparent relative z-20">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className={styles.simpleHeader}>
          <div className={styles.simpleLine} />
          <Title
            size="large"
            as="h2"
            align="center"
            color="#097d30"
            className={styles.simpleTitle}
          >
            {displayTitle}
          </Title>
          <div className={styles.simpleLine} />
        </div>

        {/* Grid */}
        <div className={styles.whyChooseGrid}>
          {displayItems.map((item, index) => {
            return (
              <div
                key={index}
                className={`${styles.whyChooseCard} ${
                  styles[`whyChooseCard_${index}`]
                }`}
              >
                <Title
                  size="small"
                  as="h3"
                  color="#ffffff"
                  style={{
                    fontSize: "14px",
                    fontWeight: 800,
                    marginBottom: "12px",
                    textTransform: "uppercase",
                    lineHeight: 1.3,
                  }}
                >
                  {item.title}
                </Title>

                <Description
                  as="div"
                  size="small"
                  color="rgba(255, 255, 255, 0.9)"
                  className={styles.whyChooseContent}
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHTMLKeepStyleWithFont(item.description),
                  }}
                />

                {item.picture && (
                  <div className={styles.whyChooseImg}>
                    <img
                      src={item.picture}
                      alt={item.title}
                      className="w-full h-auto object-contain"
                      loading="lazy"
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
